import React from 'react';
import { Menu, Icon, Dropdown, Tooltip } from 'antd';
import Locale from '../../locale';
import { FormattedMessage } from 'react-intl';

export class LangMenu extends React.Component {
  onSelect = ({ item, key }) => {
    Locale.set(key);
    window.location.reload();
  };

  render() {
    const current = Locale.getLocale();
    const locales = Locale.locales();
    let menuItems = [];
    for (let k in locales) {
      let l = locales[k];
      menuItems.push(
        <Menu.Item disabled={l.disabled} key={k}>
          {l.title}
        </Menu.Item>
      );
    }
    const menu = (
      <Menu selectedKeys={[current.locale]} onClick={this.onSelect} className="landing__header--dropdown">
        {menuItems}
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <a className="ant-dropdown-link" href="/lang-menu">
          <span>
            <FormattedMessage
              id="landing.langmenu.title"
              defaultMessage="Language"
              description="Lang menu placeholder for dropdown"
            />
          </span>
          <Icon type="caret-down" />
        </a>
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/lang-menu.js